import { getAuthToken } from '../utils/cookieUtils';
import { API_CONFIG } from '../utils/constants';
import axios from 'axios';

let _cache = null;
let _pending = null;

/**
 * Fetches mechanic statuses from the DB-driven endpoint.
 * Deduplicates concurrent requests and caches the result for the lifetime of the page session.
 * @returns {Promise<Array<{ id: string, name: string }>>}
 */
export const loadMechanicStatuses = async () => {
  if (_cache) return _cache;
  if (_pending) return _pending;

  _pending = axios.get(
    `${API_CONFIG.BASE_URL}${API_CONFIG.BREAKDOWNS.GET_MECHANIC_STATUSES}`,
    {
      headers: { Authorization: `Bearer ${getAuthToken()}`, Accept: '*/*' },
      params: { Type: 'PWA' },
    }
  ).then(res => {
    _cache = Array.isArray(res.data) ? res.data : [];
    _pending = null;
    return _cache;
  }).catch(() => {
    _pending = null;
    return [];
  });

  return _pending;
};
